<template>   
    <div id="mobileApp">
        <popup-posts :isMobile="true"/>
        <header>
            <div class="search_box">
                <search-box/>    
            </div>
        </header>
        <main>            
            <router-view/>           
        </main>  
       
        <nav-bottom/>
    </div> 
</template>

<script>
import SearchBox from '@/mobile/components/ui/SearchBox';
import NavBottom from '@/mobile/components/ui/NavBottom';
import PopupPosts from '@/components/posts/PostPopup';
export default {   
    data(){
        return{
            
        }
    },
    components: {
        SearchBox,NavBottom ,PopupPosts      
    },   
    created() {
        this.$store.dispatch("menu/fetchDocumentLists");
        this.fetchBanners();  
    },
    // updated(){  
    //     this.fullScreen();        
    // },
    methods:{
        async fetchBanners() {      
            try {
                const response = await this.$store.dispatch("banner/fetchBanners")
                console.log(response);                
                //console.log("안나오는듯",this.postlists.data.length);
            }catch(error){
                console.log(error.response);
            }        
        },
        fullScreen(){
            //전체 화면으로 해제 기능이 필요하다
            if(document.documentElement.requestFullscreen)
            {
                document.querySelector("#mobileApp").requestFullscreen();
            }else if(document.documentElement.webkitRequestFullScreen)
            {
                document.querySelector("#mobileApp").webkitRequestFullScreen();
            } 
        }        
    }
    
}
</script>

<style lang="scss">
body{
    background:#eaeef3;
}
.mobileApp{
    font-size:16px;
   // margin-bottom:150px;    
}
#mobileApp{   
    font-family: nanumgothic;
    
    header{
        height:50px;
        background:#fff;
        .search_box{
            height:50px;
        }
    }    
   
    .swiper_wrap{
        height:100vh;overflow-y:scroll
    }
    .banner_top{
        background:skyblue;
        height:100px;
        line-height: 80px;
    }
    .page_title {
        margin-top:0;
    }
}
.scrollToTop{
    width:40px;
    height:40px;
    position: fixed;
    z-index: 10000;
    bottom:70px;
    right:20px;     
    background: rgb(255, 255, 255);
    display: none;
    border: 1px solid rgb(214, 214, 214);
    opacity: 0.8;       
    box-shadow: rgba(100, 100, 111, 0.3) 0px 7px 29px 0px;       
    font-size:16px;
    color:rgb(165, 165, 165)
}
.showscrollToTop{
    display: flex;
    justify-content: center;
    align-items: center;
}
.previousPage{
    width:40px;
    height:40px;
    position: fixed;
    z-index: 10000;
    bottom:70px;
    left:20px;     
    background: rgb(255, 255, 255);
    display: none;
    border: 1px solid rgb(214, 214, 214);
    opacity: 0.8;       
    box-shadow: rgba(100, 100, 111, 0.3) 0px 7px 29px 0px;       
    font-size:16px;
    color:rgb(165, 165, 165);
    display: flex;
    justify-content: center;
    align-items: center; 
}

</style>
